import { render } from "./HeroSidebar.vue?vue&type=template&id=7e7fd1b8&scoped=true"
import script from "./HeroSidebar.vue?vue&type=script&lang=js"
export * from "./HeroSidebar.vue?vue&type=script&lang=js"

import "./HeroSidebar.vue?vue&type=style&index=0&id=7e7fd1b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e7fd1b8"]])

export default __exports__